// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__10ozu","colMin":"styles_colMin__2q70e","colCheckbox":"styles_colCheckbox__2xmfM"};